module.exports = __webpack_public_path__ + "static/media/content_image.8f0a8bc8.png";